/**
 * Storage compatible avec SSR.
 * En environnement serveur (Node.js), localStorage n'existe pas.
 * Ce module fournit un fallback no-op pour éviter ReferenceError.
 */
const noopStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

export const ssrSafeLocalStorage =
  typeof localStorage !== "undefined" ? localStorage : noopStorage;
